import { createContext, useContext, type ReactNode } from 'react';
import type { NodePath } from '@/components/tree-dnd/tree-dnd-types';

type ConditionEditSheetConfig = {
  path: NodePath;
  parentPath: NodePath;
  showAddAnother: boolean;
  showMoreOptions: boolean;
};

const ConditionEditSheetConfigContext =
  createContext<ConditionEditSheetConfig | null>(null);

export function ConditionEditSheetConfigProvider({
  path,
  parentPath,
  showAddAnother,
  showMoreOptions,
  children,
}: {
  path: NodePath;
  parentPath: NodePath;
  showAddAnother: boolean;
  showMoreOptions: boolean;
  children: ReactNode;
}) {
  return (
    <ConditionEditSheetConfigContext.Provider
      value={{ path, parentPath, showAddAnother, showMoreOptions }}
    >
      {children}
    </ConditionEditSheetConfigContext.Provider>
  );
}

export function useConditionEditSheetConfig() {
  return useContext(ConditionEditSheetConfigContext);
}
